import { ShippingConfig } from "@/services/marketplace/shippingMethod/shippingMethodConfig";
import { gettext } from "@/services/translation";

export class QuantityPerPackageNotValidException extends Error {}

export function validateQuantityPerPackage(quantity: number | undefined): quantity is number {
  if (quantity === undefined) {
    throw new QuantityPerPackageNotValidException(gettext.$gettext("Počet kusů musí být vyplněn."));
  }

  if (typeof quantity !== "number") {
    throw new QuantityPerPackageNotValidException(gettext.$gettext("Nevalidní hodnota."));
  }

  if (quantity < ShippingConfig.minQuantityInOnePackage) {
    const msg = gettext.$gettext("Počet kusů musí být větší než %{min}.", { min: ShippingConfig.minQuantityInOnePackage });
    throw new QuantityPerPackageNotValidException(msg);
  }

  if (quantity > ShippingConfig.maxQuantityInOnePackage) {
    const msg = gettext.$gettext("Počet kusů nesmí být větší než %{max}.", { max: ShippingConfig.maxQuantityInOnePackage });
    throw new QuantityPerPackageNotValidException(msg);
  }

  return true;
}
